import { z } from 'zod';

const translationResponseSchema = z.object({
  items: z.array(z.string()),
});

type TranslateApiResponse = {
  status: number;
  body: unknown;
};

export type ParsedTranslateResponse = { items: string[] } | { error: string };

export const parseTranslateResponse = (
  response: TranslateApiResponse,
  expectedLength: number,
): ParsedTranslateResponse => {
  if (response.status !== 200) {
    return { error: `Failed to translate: ${response.status}` };
  }
  const parsed = translationResponseSchema.safeParse(response.body);
  if (!parsed.success) {
    return { error: 'Translation response was malformed' };
  }
  if (parsed.data.items.length !== expectedLength) {
    return {
      error: `Translation returned ${parsed.data.items.length} items, expected ${expectedLength}`,
    };
  }
  return { items: parsed.data.items };
};
